<app-page-body [class]="'tw-pt-2'" *ngIf="!isVisibleHelpPage">
  <!-- header -->
  <app-page-header
    custom-header
    [title]="title | translate"
    [loading]="loading"
    [showAddBtn]="false"
    [showAuditBtn]="false"
    (onShowHelp)="onShowHelpPage()"
  >
    <div class="card-toolbar" after-btns>
      @if (!formPageConfig?.isEditMode) {
      <!-- open sendQueue -->
      <page-header-btn
        [name]="
          permissionService.userState()?.isSuperAdmin
            ? 'sendQueue'
            : 'currentUserSendQueue'
        "
        icon="mdi-email-multiple-outline"
        [title]="
          permissionService.userState()?.isSuperAdmin
            ? 'pages.sendQueue.title'
            : 'pages.sendQueue.userTitle'
        "
        btnColor="btn-light"
      ></page-header-btn>

      <!-- open outboxMessages -->
      <page-header-btn
        [name]="
          permissionService.userState()?.isSuperAdmin
            ? 'userOutboxMessages'
            : 'currentUserOutboxMessages'
        "
        icon="mdi-inbox-arrow-up"
        iconSize="mdi-22px"
        [title]="
          permissionService.userState()?.isSuperAdmin
            ? 'pages.outboxMessages.title'
            : 'pages.outboxMessages.userTitle'
        "
        btnColor="btn-light-info"
      ></page-header-btn>
      }

      <!------------------------- begin Edit Mode ---------------------------->
      <ng-container *ngIf="formPageConfig?.isEditMode">
        <!-- refresh btn -->
        <a
          class="btn btn-light txt-lg button-shadow tw-mx-1 text-blue btn-hover-rise"
          mat-ripple
          [matTooltip]="'common.refresh' | translate"
          (click)="onReset()"
        >
          <i class="mdi mdi-refresh mdi-20px tw-p-0 text-blue"></i>
        </a>

        <!-- back btn -->
        <a
          class="btn btn-light txt-lg button-shadow tw-mx-1 btn-hover-rise"
          mat-ripple
          [matTooltip]="'common.back' | translate"
          (click)="onClose()"
        >
          <i class="mdi mdi-arrow-left mdi-20px tw-p-0"></i>
        </a>
      </ng-container>
      <!------------------------- end Edit Mode ---------------------------->
    </div>
  </app-page-header>

  <div class="app-page-content">
    <form [formGroup]="form" autocomplete="off">
      <div class="row panels-row">
        <section class="md:tw-w-2/3">
          <fieldset class="tw-h-full">
            <legend class="tw-flex-center">
              <i class="mdi mdi-card-account-phone tw-ml-2"></i>
              {{ "common.phonebook" | translate }}
              <span
                (click)="onRefreshPhonebook()"
                class="mdi mdi-refresh tw-mr-5 mdi-18px text-light tw-cursor-pointer"
                [matTooltip]="'common.refresh' | translate"
              ></span>
            </legend>

            <phonebook-selector
              (recipientsChange)="getPhonebookRecipients($event)"
              (globalIndexChange)="getGlobalIndex($event)"
            >
            </phonebook-selector>
          </fieldset>
        </section>

        <section class="md:tw-w-1/3">
          <fieldset class="tw-h-full">
            <legend class="tw-flex-center">
              <i class="mdi mdi-message-cog tw-ml-2"></i>
              {{ "common.messageInformation" | translate }}
            </legend>

            <div
              class="tw-flex tw-justify-between tw-items-center flex-column tw-h-full"
            >
              <div>
                <!-- alert -->
                <!-- <div class="alert alert-secondary border tw-mb-2 tw-mt-1">
                  <p class="tw-mb-1 tw-text-justify"> -->

                <div class="alert alert-primary border tw-mb-2 tw-mt-1">
                  <!-- <p class="tw-mb-1 tw-text-justify">
                    <span
                      [innerHTML]="'pages.sendingSystem.fastSendSmsPatternByPhonebook.toSetTheSMSTextClickOnTheSMSTemplateButtonThenChooseYourSMStemplate' | translate"></span>
                  </p> -->
                  <p class="tw-mb-0 tw-font-medium tw-text-justify">
                    <span>●</span>
                    {{
                      "pages.sendingSystem.fastSendSmsPatternByPhonebook.youAreOnlyAbleToSelectTheSMSTemplateAndYouCannotChangeTheTextOfTheMessage"
                        | translate
                    }}
                  </p>
                </div>

                <!-- senderNumberId + smsBody -->
                <!-- [smsBody]="model.smsBody" -->
                <app-sms-body
                  [form]="form"
                  [sendType]="SendTypes.Phonebook"
                  [useType]="UseTypes.Normal"
                  smsBodyControlName="smsBody"
                  senderNumberControlName="senderNumberId"
                  socialMediaMessageControlName="socialMediaFileId"
                  socialMediaApplicationControlName="socialMediaApplicationId"
                  voiceMessageControlName="voiceMessageId"
                  maxTryCountControlName="maxTryCount"
                  minuteBetweenTriesControlName="minuteBetweenTries"
                  [senderNumberId]="model.senderNumberId"
                  (finalSmsBody)="model.smsBody = $event"
                  [isReadOnlySmsBody]="true"
                  (senderNumberId)="model.senderNumberId = $event"
                  [isShowShortLink]="false"
                  [isShowEmojiPicker]="false"
                  [isAddSignature]="!formPageConfig?.isEditMode ? true : false"
                  [isAddHeader]="!formPageConfig?.isEditMode ? true : false"
                  (smsCount)="smsCount = $event"
                  (voiceMessageDetails)="
                    this.model.voiceMessageDetails = $event
                  "
                  (senderNumber)="
                    onChangeSendNumber($event);
                    isCanSendFlashSms = $event?.isCanSendFlashSms
                  "
                  (socialMediaMessageDetails)="
                    model.socialMediaDetails = $event
                  "
                >
                </app-sms-body>

                <!-- description -->
                <form-textarea
                  class="tw-w-full tw-mt-1"
                  label="common.description"
                  [(value)]="model.description"
                  [control]="form?.get('description')"
                  [rows]="1"
                >
                </form-textarea>
                <!-- isFlashSms -->
                <div
                  class="checkbox-section tw-mr-[5px] ltr:tw-ml-[5px] tw-mb-[10px] tw-mt-2"
                  *ngIf="isCanSendFlashSms"
                >
                  <mat-slide-toggle
                    [(ngModel)]="model.isFlashSms"
                    formControlName="isFlashSms"
                  >
                    {{ "common.isFlashSms" | translate }}
                  </mat-slide-toggle>
                </div>
              </div>
              <!-- submit btn -->
              <button
                type="submit"
                mat-ripple
                class="btn tw-py-2 tw-mb-1 tw-w-full button-shadow btn-hover-rise"
                [themeColor]="'btn-gradient'"
                (click)="onSubmit()"
                [disabled]="loading"
              >
                <ng-container *ngIf="!loading">
                  <!-- create mode -->
                  <ng-container *ngIf="!formPageConfig?.isEditMode">
                    {{ "common.sendSms" | translate }}
                    <i class="fas fa-paper-plane tw-text-2xl"></i>
                  </ng-container>

                  <!-- edit mode -->
                  <ng-container *ngIf="formPageConfig?.isEditMode">
                    {{ "common.editSendSms" | translate }}
                    <i class="fas fa-pen tw-text-2xl"></i>
                  </ng-container>
                </ng-container>

                <!-- loading -->
                <ng-container *ngIf="loading">
                  <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                </ng-container>
              </button>
            </div>
          </fieldset>
        </section>
      </div>
    </form>
  </div>

  <!-- sendLoading -->
  <app-special-loading *ngIf="sendLoading" special-loading type="sending">
  </app-special-loading>
</app-page-body>
<!----------------------------------------- help -------------------------------------->
<ng-container *ngIf="isVisibleHelpPage">
  <app-help-page
    menuTitle="FastSendSmsPatternByPhonebook"
    (hidePage)="onHideHelpPage()"
    [title]="title"
  >
  </app-help-page>
</ng-container>
